module.exports = __webpack_public_path__ + "assets/img/2021activity-detail.ed9452ef.png";